import React, { useContext, useState } from 'react';
import pt from 'prop-types';
import Iframe from '../iframe';
import Image, { imageProptypes } from '../image';
import { combine } from '../../../helpers/styles';
import Icon from '../icon';
import AwardBadge from '../awardBadge';
import * as styles from './styles.module.scss';
import { PreviewContext } from '../../../context/preview.context';

const Video = ({
  video,
  poster,
  width,
  height,
  className,
  badgeIcon,
  badgeYear,
  autoplay,
  controls,
  loop,
  muted,
  playBtnClassname,
  ...props
}) => {
  const isPreview = useContext(PreviewContext);

  const [videoIsPlaying, playVideo] = useState(false);

  let youtubeUrl = video.youtubeUrl;
  let portraitVideo = false;

  if (youtubeUrl && youtubeUrl.indexOf('/watch?v=') >= 0) {
    // Default youtube.com link
    youtubeUrl = video.youtubeUrl.replace('/watch?v=', '/embed/');
  } else if (youtubeUrl && youtubeUrl.indexOf('youtu.be') > -1) {
    // Shortlink
    youtubeUrl = `https://youtube.com/embed/${video.youtubeUrl
      .split('/')
      .slice(-1)}`;
  } else if (
    youtubeUrl &&
    youtubeUrl.indexOf('youtube') > -1 &&
    youtubeUrl.indexOf('shorts') > -1
  ) {
    // YouTube "Shorts" Link
    youtubeUrl = `https://youtube.com/embed/${video.youtubeUrl
      .split('/')
      .slice(-1)}`;
    portraitVideo = true;
  }

  if (poster && !videoIsPlaying) {
    return (
      <button
        onClick={() => playVideo(true)}
        className={combine(
          styles.playBtn,
          playBtnClassname && playBtnClassname
        )}
      >
        <Image
          image={poster.image}
          className={combine(styles.poster, className)}
        />
        <div className={styles.payBtnInner}>
          <Icon name="play" size="2x" className={styles.playIcon} />
        </div>
        {badgeIcon && (
          <AwardBadge
            name={badgeIcon}
            year={badgeYear}
            className={combine(styles.badge, styles.badgeIcon)}
          />
        )}
      </button>
    );
  }

  if (youtubeUrl) {
    // replace residual query parameters that were in original url
    youtubeUrl = youtubeUrl.split('&')[0];
    return (
      <div
        className={combine(
          styles.iframeContainer,
          portraitVideo && styles.portraitVideo,
          className
        )}
      >
        <Iframe
          width="100%"
          src={`${youtubeUrl}${autoplay ? '?autoplay=1' : '?rel=0'}`}
        />
      </div>
    );
  }
  let vimeoUrl = video.vimeoUrl;
  if (vimeoUrl) {
    const vimeoUrlId = video.vimeoUrl.split('/').pop();
    return (
      <div className={combine(styles.iframeContainer, className)}>
        <Iframe
          width="100%"
          src={`https://player.vimeo.com/video/${vimeoUrlId}`}
        />
      </div>
    );
  }
  const localVideoSource = isPreview
    ? video.localVideo?.url
    : video.localVideo?.file?.url;

  if (localVideoSource) {
    return (
      <video
        width={width}
        height={height}
        autoPlay={autoplay}
        controls={controls}
        src={localVideoSource}
        preload="none"
        loop={loop}
        muted={muted}
        className={combine(styles.video, className)}
        {...props}
      ></video>
    );
  }

  return '';
};

export const videoPropTypes = {
  youtubeUrl: pt.string,
  localVideo: pt.shape({
    file: pt.shape({
      url: pt.string,
    }),
  }),
};

Video.propTypes = {
  video: pt.shape(videoPropTypes).isRequired,
  poster: pt.shape(imageProptypes),
  width: pt.string,
  height: pt.string,
  className: pt.string,
  badgeIcon: pt.string,
  badgeYear: pt.number,
  autoplay: pt.bool,
  controls: pt.bool,
  loop: pt.bool,
  muted: pt.bool,
  playBtnClassname: pt.string,
};

Video.defaultProps = {
  width: '',
  height: '',
  poster: null,
  className: '',
  badgeYear: 2021,
  badgeIcon: '',
  autoplay: true,
  controls: true,
  loop: false,
  muted: false,
  playBtnClassname: '',
};

export default Video;
